export default __webpack_public_path__ + "static/media/carousel.7a5aa428.png";